import React from 'react';

export const Insight = () => {
  return (
    <section className="py-32 md:py-40 bg-white relative overflow-hidden">
      {/* Subtle ambient background */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 -left-20 w-[400px] h-[400px] bg-turret-purple/5 rounded-full blur-[100px]" />
        <div className="absolute bottom-1/4 -right-20 w-[400px] h-[400px] bg-indigo-500/5 rounded-full blur-[100px]" />
      </div>

      <div className="section-container relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-turret-purple font-semibold tracking-wide uppercase text-sm mb-6">
            The Insight
          </p>
          
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-neutral-900 mb-10 leading-[1.1] tracking-tight">
            AI conversations have structure—
            <br />
            <span className="gradient-text">you just can't see it.</span>
          </h2>

          <div className="space-y-6 text-lg text-neutral-500 leading-relaxed mb-16 max-w-4xl mx-auto">
            <p>
              Users move through semantic steps in a session: asking, refining, retrying, or abandoning.
            </p>
            <p>
              Turret groups messages by <span className="relative font-semibold px-2 py-0.5" style={{ color: "white" }}>
                <span 
                  className="absolute -left-1 top-1/2 -z-10" 
                  style={{ 
                    width: "calc(100% + 8px)", 
                    height: "70%", 
                    transform: "translateY(-45%) rotate(-1deg) skewX(-2deg)",
                    background: "linear-gradient(90deg, rgba(139, 92, 246, 0.75) 0%, rgba(139, 92, 246, 0.85) 40%, rgba(139, 92, 246, 0.8) 100%)",
                    borderRadius: "4px 8px 6px 10px",
                  }}
                />
                meaning
              </span> and maps how users move between them.
            </p>
          </div>

          {/* Feature badge - stacks on mobile */}
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 px-6 sm:px-8 py-5 sm:py-5 rounded-3xl sm:rounded-full bg-gradient-to-b from-slate-50 to-white border border-slate-200 shadow-lg shadow-slate-200/50">
            <div className="w-12 h-12 sm:w-10 sm:h-10 rounded-full bg-gradient-to-br from-turret-purple to-turret-purple-light flex items-center justify-center shadow-lg shadow-turret-purple/25 flex-shrink-0">
              <svg className="w-6 h-6 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <span className="text-base sm:text-lg font-semibold text-neutral-900 text-center sm:text-left">
              Product analytics for language, not clicks.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
